import { useState } from 'react'
import { useRotation } from '../model'
import { FullScreenPDFDialog } from './fullscreen-pdf-dialog'
import { type PDFPaginationInfo, PDFContent } from './pdf-content'

export function PDFDocument({
  className,
  file,
  startPage = 1,
  endPage,
  isLoading,
  onDownload,
  onOpenInNewTab,
  onInteraction,
  initialFitToWidth = false,
  showFullscreen = true,
  onPaginationReady,
}: {
  className?: string
  file: string | null
  startPage?: number
  endPage?: number
  isLoading?: boolean
  onDownload?: () => void
  onOpenInNewTab?: () => void
  onInteraction?: (type: string) => void
  initialFitToWidth?: boolean
  showFullscreen?: boolean
  onPaginationReady?: (info: PDFPaginationInfo) => void
}) {
  const [isFullScreen, setIsFullScreen] = useState(false)
  const rotation = useRotation()

  return (
    <>
      <PDFContent
        className={className}
        file={file}
        startPage={startPage}
        endPage={endPage}
        isLoading={isLoading}
        onDownload={onDownload}
        onOpenInNewTab={onOpenInNewTab}
        initialFitToWidth={initialFitToWidth}
        onExpandContent={
          showFullscreen
            ? () => {
                setIsFullScreen(true)
                onInteraction?.('fullscreen')
              }
            : undefined
        }
        onInteraction={onInteraction}
        onPaginationReady={onPaginationReady}
        rotation={rotation}
      />

      {showFullscreen && (
        <FullScreenPDFDialog
          open={isFullScreen}
          onClose={() => setIsFullScreen(false)}
          file={file}
          startPage={startPage}
          endPage={endPage}
          onDownload={onDownload}
          onOpenInNewTab={onOpenInNewTab}
          initialFitToWidth={initialFitToWidth}
          rotation={rotation}
        />
      )}
    </>
  )
}
